import { STATES } from '../../../constants';
import SmartHomeOwnController from './smart-home.controller';

const template = `
  <div id="upd-smart-home-own-app" class="micro-app-fixes"></div>
`;

export default function SmartHomeOwnConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_SMART_HOME_OWN, {
    url: '/smart-home',
    disabledBreadcrumb: true,
    data: {
      permissions: 'signedIn',
    },
    views: {
      '@': {
        template,
        controller: SmartHomeOwnController,
      },
    },
    scrollTop: true,
    title: 'Automate Your Home',
    analytics: {
      ignore: true,
    },
  });
}
